import { Box } from '@mui/material';
import { useProduct } from '../ProductContext';
import { AdditionalGroupHeader } from './AdditionalGroupHeader';
import { AdditionalTile } from './AdditionalTile';

export function Additionals() {
	const { product } = useProduct().state;
	const groups = product!.additionalGroups;

	const list = groups.map((group) => (
		<Box key={`group:${group.id}`}>
			<AdditionalGroupHeader group={group} />
			{group.additionals.map((additional) => (
				<AdditionalTile
					key={`additional:${additional.id}`}
					group={group}
					additional={additional}
				/>
			))}
		</Box>
	));

	return <>{list}</>;
}
